









import { Route } from 'vue-router';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getExecutionStepFromPath } from '@/services/helpers';

import Stepper from '@/components/Stepper/Stepper';
import Logger from '@/services/Logger';

@Component({
  components: { Stepper },
})
export default class App extends Vue {
  @Watch('$route')
  public onRouteChanged(route: Route, oldRoute: Route) {
    const currentStep = getExecutionStepFromPath(route.path);
    const prevStep = getExecutionStepFromPath(oldRoute.path);

    Logger.logChangeStep(currentStep, prevStep);
  }
}
